import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, makeStyles, ChannelsList, ChatIframe } from "../../..";
import SelectComponent from "../../../Atoms/Select/Select";
import InputLabel from "@material-ui/core/InputLabel";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper
    },
    inline: {
      display: "inline"
    },
    selectServiceContainer: {
      padding: "20px"
    }
  };
});

var WebInbox = function WebInbox(props) {
  // console.log("WebManagerInbox props", props);
  var services = props.services,
      translation = props.translation,
      auth_token = props.auth_token,
      chatServer = props.chatServer,
      direct_messages = props.direct_messages,
      _updateDirectMessages = props.updateDirectMessages,
      getServiceChannels = props.getServiceChannels;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      room = _useState2[0],
      setRoom = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      type = _useState4[0],
      setType = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      mode = _useState6[0],
      setMode = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      channelName = _useState8[0],
      setChannelName = _useState8[1]; // const [channelsLoading, setChannelsLoading] = useState(true);


  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedService = _React$useState2[0],
      setSelectedService = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      channels = _React$useState4[0],
      setChannels = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      _direct_messages = _React$useState6[0],
      _setDirectMessages = _React$useState6[1];

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      users = _React$useState8[0],
      setUsers = _React$useState8[1];

  var classes = useStyles();

  var handleServiceChange = function handleServiceChange(event) {
    // console.log("event", event);
    setChannels(null);
    setSelectedService(event.target.value);
  };

  useEffect(function () {
    selectedService && getServiceChannels(selectedService).then(function (data) {
      // console.log("channels", data);
      setChannels({
        groups: _toConsumableArray(data.groups),
        rocket_channels: _objectSpread({}, data.rocket_channels)
      });

      _setDirectMessages(_toConsumableArray(data.direct_messages));

      setUsers(_toConsumableArray(data.users)); // setChannelsLoading(false);
    });
  }, [selectedService]);
  useEffect(function () {
    // console.log("useEffect _setDirectMessages", direct_messages);
    _setDirectMessages(direct_messages);
  }, [direct_messages]);

  var handleClickItem = function handleClickItem(room, type, channelName) {
    // console.log("handleClickItem", room, type, channelName);
    // setActiveChannel(room)
    setRoom(room);
    setType(type);
    setChannelName(channelName);
  };

  var startNewDirectMessage = function startNewDirectMessage(room, name, mode) {
    // console.log("startNewDirectMessage", room);
    setRoom(room);
    setType("direct");
    setMode(mode);
    setChannelName(name); // updateDirectMessages(selectedService);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selectServiceContainer
  }, /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true,
    id: "demo-simple-select-placeholder-label-label"
  }, translation && translation.selects ? translation.selects.service : "Choose Service"), /*#__PURE__*/React.createElement(SelectComponent, {
    items: services,
    value: selectedService,
    handleChange: handleServiceChange
  })), channels && /*#__PURE__*/React.createElement(ChannelsList, {
    channels: channels,
    users: users,
    direct_messages: _direct_messages,
    translation: translation.blocks,
    handleClickItem: handleClickItem,
    startNewDirectMessage: startNewDirectMessage
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 8
  }, /*#__PURE__*/React.createElement(ChatIframe, {
    room: room,
    type: type,
    channelName: channelName,
    mode: mode,
    auth_token: auth_token,
    chatServer: chatServer,
    updateDirectMessages: function updateDirectMessages() {
      return _updateDirectMessages(selectedService);
    }
  }))));
};

export { WebInbox };